import React from "react";

export default function GetInvolved() {
  return (
    <div className="text-white max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold mb-3">Get involved</h1>
      <p className="text-gray-300 mb-6">
        Urban Unity Network grows when residents, groups, and local businesses share what’s happening and support each other.
        Here are a few ways to get involved.
      </p>

      <div className="grid gap-6 md:grid-cols-2">
        <section className="bg-black/40 border border-white/10 rounded-2xl p-6">
          <h2 className="text-xl font-semibold mb-2">Share something local</h2>
          <p className="text-sm text-gray-300">
            Running an activity? Offering a service? Know a space or opportunity others should see?
            Submit it through the Map, Events, or Directory pages. Submissions are reviewed before going live.
          </p>
        </section>

        <section className="bg-black/40 border border-white/10 rounded-2xl p-6">
          <h2 className="text-xl font-semibold mb-2">Volunteer</h2>
          <p className="text-sm text-gray-300">
            We regularly need help with community events, outreach, and the UUN Food Bank project.
            If you can offer time (even occasionally), get in touch.
          </p>
          <div className="mt-4">
            <a
              className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-500"
              href="mailto:info@urbanunitynetwork.com?subject=Volunteer%20-%20Urban%20Unity%20Network"
            >
              Email to volunteer
            </a>
          </div>
        </section>

        <section className="bg-black/40 border border-white/10 rounded-2xl p-6">
          <h2 className="text-xl font-semibold mb-2">Partner / sponsor</h2>
          <p className="text-sm text-gray-300">
            If you’re a business, school, or organisation and want to support community-led activity —
            we can collaborate on events, wellbeing support, training, or visibility for local opportunities.
          </p>
          <div className="mt-4">
            <a
              className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-[#E63946] text-white text-sm font-semibold hover:bg-[#f25561]"
              href="mailto:info@urbanunitynetwork.com?subject=Partnership%20-%20Urban%20Unity%20Network"
            >
              Partnership enquiry
            </a>
          </div>
        </section>

        <section className="bg-black/40 border border-white/10 rounded-2xl p-6">
          <h2 className="text-xl font-semibold mb-2">Feedback</h2>
          <p className="text-sm text-gray-300">
            Tell us what’s missing, what’s confusing, or what would make this more useful locally.
            Small tweaks can make a big difference.
          </p>
          <div className="mt-4">
            <a
              className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-white/10 text-white text-sm font-semibold hover:bg-white/20"
              href="mailto:info@urbanunitynetwork.com?subject=Feedback%20-%20Urban%20Unity%20Network"
            >
              Send feedback
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}
